/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectTaskCommand } from '../../models/update-project-task-command';
import { UpdateProjectTaskCommandResult } from '../../models/update-project-task-command-result';

export interface ApiProjectTaskUpdateProjectTaskPost$Plain$Params {
      body?: UpdateProjectTaskCommand
}

export function apiProjectTaskUpdateProjectTaskPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectTaskUpdateProjectTaskPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskUpdateProjectTaskPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectTaskCommandResult>;
    })
  );
}

apiProjectTaskUpdateProjectTaskPost$Plain.PATH = '/api/ProjectTask/UpdateProjectTask';
